import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";
import type { AuthenticationsOutput } from "@zapier/bff";

export function useTransferAuthentication() {
  const queryClient = useQueryClient();

  const authenticationsKey = getQueryKey(
    trpc.authentication.authentications,
    undefined,
    "any",
  );
  const connectionStatsKey = getQueryKey(
    trpc.authentication.connectionStats,
    undefined,
    "any",
  );

  const mutation = trpc.authentication.transferAuthentication.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: ({ customuserId, id }) => {
      if (!id || !customuserId) {
        return;
      }

      // Update Authentication under the authentications list key
      queryClient.cancelQueries({ queryKey: authenticationsKey });
      queryClient.setQueriesData(
        {
          queryKey: authenticationsKey,
          type: "active",
        },
        (old: AuthenticationsOutput | undefined) => {
          if (old?.results) {
            const updatedAuthenticationsArray = old?.results.map((item) =>
              item.id === id ? { ...item, customuserId } : item,
            );

            // this needs to return a new object ref for RQ to detect the change
            return {
              ...old,
              results: updatedAuthenticationsArray,
            };
          }

          return old;
        },
      );
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: () => {
      // Invalidate authentications key to refetch data
      queryClient.invalidateQueries({ queryKey: authenticationsKey });
      queryClient.invalidateQueries({ queryKey: connectionStatsKey });
    },
  });

  return {
    changeOwner: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
